<template>
  <div class="caseDetailContent">
    <caseDetail :caseDetailData="caseData"></caseDetail>
  </div>
</template>

<script type="text/ecmascript-6">
import caseDetail from '@/components/caseDetail.vue';
import { getStore, getUrlParams } from '@/utils/utils';
import { getCaseDetails } from '@/api/application';

export default {
  name: "userCaseDetail",
  components: {
    caseDetail,
  },
  data() {
    return {
      caseId: '',
      caseData: {},
      param: {
        id: '',
        roleCode: '',
      },
    };
  },
  mounted() {
    if (getStore('caseId')) {
      this.caseId = getStore('caseId');
      this.param.id = getStore('caseId');
    }
    if (getStore('loginRole')) {
      const loginRoleInfo = JSON.parse(getStore('loginRole'));
      this.param.roleCode = loginRoleInfo.roleCode;
    }
    this.getCaseDetail();
  },
  methods: {
    getCaseDetail() {
      const self = this;
      getCaseDetails(self.param).then((res) => {
        if (res.data.code = 200) {
          self.caseData = res.data.result;
        } else {
          self.$toast(res.data.message);
        }
      });
    },
  },
};
</script>
<style rel="stylesheet/scss" scoped lang="scss">
.caseDetailContent {
}
</style>

